export interface ListboxItem<T> {
  label: string;
  value: T;
  disabled?: boolean;
}
